import config from '../services/config'

export function authUserId(user: { _id?: string; id?: string } | null | undefined): string {
  return String(user?._id || user?.id || '')
}

export function userInitials(name?: string | null): string {
  const parts = (name || '').split(' ').filter(Boolean)
  const letters = parts
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join('')
  return letters || 'U'
}

export function userAvatarUrl(avatar?: string | null): string | null {
  if (!avatar || typeof avatar !== 'string') return null
  const trimmed = avatar.trim()
  if (!trimmed || trimmed === 'null' || trimmed === 'undefined') return null
  if (/^https?:\/\//i.test(trimmed) || trimmed.startsWith('blob:') || trimmed.startsWith('data:')) {
    return trimmed
  }
  const base = String(config.baseURL || '').replace(/\/+$/, '')
  if (!base) return null
  const path = trimmed.startsWith('/') ? trimmed : `/${trimmed}`
  return `${base}${path}`
}
